/**
 * MainloadingServe 常量配置
 */

export const AUDIT_JOB_CREATE_API_PATH = '/audit/jobs';
export const AUDIT_REQUEST_TIMEOUT = 30000;
export const AUDIT_POLL_FALLBACK_MS = 600;
export const MAX_CONCURRENT_LOAD_TASKS = 3;
export const LOAD_TIMEOUT_MS = 5000;

// 阶段二归档图片轮询重载配置
export const RELOAD_POLL_INTERVAL_MS = 5000;                 // Image 快速轮询间隔：5s
export const RELOAD_STATUS_POLL_INTERVAL_MS = 30000;         // restore_status 兜底查询间隔：30s
export const RELOAD_MAX_POLL_TIME_MS = 10 * 60 * 1000;       // 最大轮询时间：10 分钟
export const STATUS_CHECK_EVERY_N_ATTEMPTS = Math.floor(RELOAD_STATUS_POLL_INTERVAL_MS / RELOAD_POLL_INTERVAL_MS); // 每 6 次 Image 轮询查一次状态
export const RELOAD_MAX_POLL_ATTEMPTS = 120;                 // 基于 10 分钟预算的等效最大尝试次数（用于进度计算）
export const RESTORE_BATCH_SIZE = 50;
export const POLL_PROGRESS_MAX_PENDING = 0.95;               // pending 单项最高进度（防止未成功时跑满）
export const ENABLE_AUDIT_DEBUG_LOG = process.env.NODE_ENV !== 'production';
export const DEFAULT_AUDIT_BASE_URL = 'https://fc-imagudit-mvp-zllilfnpsu.cn-shenzhen.fcapp.run';
export const PRODUCTION_AUDIT_BASE_URL = 'https://alifun.litiskr.cn';

// 阶段三审核总时间预算（毫秒）。
// 服务端任务整体超时约为 300s，前端预算略高于服务端，确保正常终态一定先到，
// 前端只兜住服务端长期不返回终态的异常场景。
export const AUDIT_TIME_BUDGET_MS = 360000;

// 绝对轮询次数硬兜底，防止极端异常下死循环
export const AUDIT_HARD_MAX_POLL_COUNT = 500;

// 轮询间隔配置（根据图片数量自适应）
export const POLL_INTERVAL_CONFIG = {
  small: { maxCount: 10, initial: 400, min: 300, max: 800 },
  medium: { maxCount: 50, initial: 600, min: 400, max: 1200 },
  large: { maxCount: 200, initial: 1000, min: 600, max: 2000 },
  xlarge: { maxCount: Infinity, initial: 1500, min: 1000, max: 3000 }
};

// 审核状态
export const AUDIT_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  PASSED: 'passed',
  REJECTED: 'rejected',
  FAILED: 'failed',
  TIMEOUT: 'timeout'
};

// 提示语文本
export const TIPS = [
  '请勿上传涉黄、涉政、暴恐等违规内容，共同维护良好的分享环境',
  '甜豆相册的绿色健康，需要你我一起守护',
  '耐心等待片刻，美好即将呈现'
];
